import { MDSChip, MDSDropDown } from '@marqvision/mds/core';
import { IcoArrowDownOutline } from '@marqvision/mds/assets';
import { PiracyCommonEnumsCrCRStatusEnum } from '~/swagger/data-contracts';
import { getFilterSelected } from '~/utils';
import { requestStatusLabel } from '../../@constants';
import { RequestFilter } from '../../@types';

const list = [
  { label: 'All', value: null },
  ...Object.values(PiracyCommonEnumsCrCRStatusEnum).map((value) => ({ label: requestStatusLabel[value], value })),
];

type Props = {
  selected?: PiracyCommonEnumsCrCRStatusEnum;
  onChange: (value: RequestFilter[keyof RequestFilter]) => void;
};

export const StatusFilter = (props: Props) => {
  const { selected, onChange } = props;

  const handleChange = (value: unknown) => {
    onChange(value as PiracyCommonEnumsCrCRStatusEnum);
  };

  return (
    <MDSDropDown
      value={selected || null}
      list={list}
      onChange={handleChange}
      renderAnchorComponent={(_, open) => (
        <MDSChip
          variant="fill"
          color="bluegray"
          label="Status"
          endIcon={<IcoArrowDownOutline />}
          onClick={open}
          selected={selected && getFilterSelected([selected], list)}
        />
      )}
    />
  );
};